import { render, staticRenderFns } from "./OverlayBase.vue?vue&type=template&id=640d05d5"
import script from "./OverlayBase.vue?vue&type=script&lang=ts"
export * from "./OverlayBase.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports